export function getButtonText(
  value: string,
  t: (key: string) => string,
): string {
  switch (value) {
    case 'auth':
      return t('Test Connection');
    case 'fetch_samples':
      return t('Fetch Data');
    case 'show_permissions':
      return t('Request Information');
    case 'reset_cached_vessel_data':
      return t('Clear State');
    case 'view_cached_vessel_data':
      return t('Get State');
    default:
      return t('Test Action');
  }
}

/** A runner error arrives either as a string or as a dict ({action_id, error})
 *  from cdip's execute routes. Coerce so nothing renders "[object Object]". */
export function getResponseErrorMessage(
  testActionResponse: any,
): string | undefined {
  const raw = testActionResponse?.error ?? testActionResponse?.detail;
  if (typeof raw === 'string') return raw || undefined;
  if (raw && typeof raw === 'object' && 'error' in raw)
    return String(raw.error) || undefined;
  return undefined;
}

export function getResponseText(
  value: string,
  testActionResponse: any,
  t: (key: string) => string,
): any[] {
  // Credentials answer one question, so a transport failure reads the same as a
  // rejection. Keeps this wording identical to the draft flow, which has no
  // "Action Failed" state; the cause stays visible under View Details.
  if (value === 'auth') {
    const ok =
      !testActionResponse?.error && !!testActionResponse?.valid_credentials;
    return ok
      ? [t('Valid Credentials'), true]
      : [t('Invalid Credentials'), false];
  }
  if (testActionResponse?.error) {
    return [t('Action Failed'), false];
  }
  switch (value) {
    case 'fetch_samples':
      return testActionResponse.observations.length > 0
        ? [t('Fetch Successful'), true]
        : [t('Fetch Unsuccessful'), false];
    case 'show_permissions':
      return testActionResponse.data
        ? [t('Fetch Successful'), true]
        : [t('Fetch Unsuccessful'), false];
    default:
      return [t('Response Received'), null];
  }
}

/** The account an `auth` check ran as, when the runner reports one. Only
 *  some runners send `connected_as`, so anything else reads as absent. */
export function getConnectedAs(testActionResponse: any): string | undefined {
  const raw = testActionResponse?.connected_as;
  return typeof raw === 'string' && raw.trim() ? raw.trim() : undefined;
}
